// extracted by mini-css-extract-plugin
export default {"icon":"upload-csv-modal_icon__hq50M","paragraph":"upload-csv-modal_paragraph__y8Heo","section":"upload-csv-modal_section__A96E1","number":"upload-csv-modal_number__ymA5A"};